import {useIntl} from "react-intl";
import SuggestedUsersAsyncPaginatedTableFilter from "../components/SuggestedUsersAsyncPaginatedTableFilter";
import SuggestedUsersBooleanTableFilter from "../components/SuggestedUsersBooleanTableFilter";
import SuggestedUsersTableFilter from "../components/SuggestedUsersTableFilter";
import {NotificationsContext} from "../ui-components/Notifications";
import {useContext} from "react";
import SuggestedUsersOnlyExcludeNullsFilter from "../components/SuggestedUsersOnlyExcludeNullsFilter";
const createILikeAnyPagination = (column) => {
  return {
    column: column,
    operator: "ilike any",
    value_parser: (value) => value
  }
}
const createBooleanPagination = (column) => {
  return {
    column: column,
    operator: "bool",
    value_parser: (value) => value === "true"
  }
}
const createEqualArrayPagination = (column) => {
  return {
    column: column,
    operator: "array_equality",
    value_parser: (value) => value
  }
}

const columns = [
  {
    field:"email",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"firstname",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"lastname",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field: "imported_from",
    type: "string",
    filter: "array_equality",
    render: (rowData) => {
      return rowData.imported_from.join(", ")
    }
  },
  {
    field: "invitation_sent",
    type: "boolean",
    filter: "bool"
  },
  {
    field: "registered",
    type: "boolean",
    filter: "bool"
  },
  {
    field: "last_invitation_sent",
    type: "date",
    filter: "only_exclude_nulls"
  },
  {
    field: "license_expiration_date",
    type: "date",
    filter: "only_exclude_nulls"
  },
  {
    field: "subscription_date",
    type: "date",
    filter: "only_exclude_nulls"
  },
  {
    field: "country",
    type: "string",
    filter: "iLikeAny"
  },
  {
    field:"city",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"zip_code",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"address",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"phone",
    type:"string",
    filter: "iLikeAny"
  },
  {
    field:"mobile_phone",
    type:"string",
    filter: "iLikeAny"
  },
]

const getPagination = (column) => {
  switch (column.filter) {
    case "iLikeAny":
      return createILikeAnyPagination(column.field)
    case "bool":
      return createBooleanPagination(column.field)
    case "array_equality":
      return createEqualArrayPagination(column.field)
    case "only_exclude_nulls":
      return null
    default:
      return null
  }
}

const getFilterComponent = (column, importedFromOptions, excludeNullsRef) => {
  switch (column.filter) {
    case "iLikeAny":
      return (props) => <SuggestedUsersAsyncPaginatedTableFilter
          onChangeExcludeNulls={(value) => {
            excludeNullsRef.current = {
              ...excludeNullsRef.current,
              [column.field]: value
            }
          }} {...props}/>
    case "bool":
      return (props) => <SuggestedUsersBooleanTableFilter {...props}/>
    case "array_equality":
      return (props) => <SuggestedUsersTableFilter options={importedFromOptions} {...props}/>
    case "only_exclude_nulls":
      return (props) => <SuggestedUsersOnlyExcludeNullsFilter
          onChangeExcludeNulls={(value) => {
            excludeNullsRef.current = {
              ...excludeNullsRef.current,
              [column.field]: value
            }
          }} {...props}/>
    default:
      return null
  }
}


export const getColumns = (importedFromOptions, excludeNullsRef) => {
  const intl = useIntl();
  const {push} = useContext(NotificationsContext)
  return columns.map((column) => {
    return {
      field: column.field,
      title: intl.formatMessage({id: column.field}),
      pagination: getPagination(column),
      type: column.type,
      filterComponent: getFilterComponent(column, importedFromOptions, excludeNullsRef),
      ...(column.render && {render: column.render})
    }
  })
}

export const getExcludeNullColumns = () => {
  return columns.filter((column) => {
    return ["only_exclude_nulls", "iLikeAny"].includes(column.filter)
  }).map((column) => column.field)
}

export const NOTNULL_TOKEN = "__notnull";